import type { MessageKey } from "@wato/i18n";

export interface SettingsSearchEntry {
  readonly id: string;
  readonly labelKey: MessageKey;
  /** Path under `/w/:workspaceId/`. */
  readonly to: string;
  /** DOM id of the `SettingsAnchor` on that page. */
  readonly fieldId: string;
  /** Extra match words (Arabic + English aliases); never shown. */
  readonly keywords: readonly string[];
}

/** OWN-365: fields the settings search can jump to. Every `fieldId` is rendered by its page (tested). */
export const SETTINGS_SEARCH_INDEX: readonly SettingsSearchEntry[] = [
  {
    id: "business-name",
    labelKey: "dashboard.settings.workspace.name",
    to: "settings/workspace",
    fieldId: "field-business-name",
    keywords: ["اسم النشاط", "اسم المتجر", "اسم الشركة", "business name"],
  },
  {
    id: "timezone",
    labelKey: "dashboard.settings.workspace.timezone",
    to: "settings/workspace",
    fieldId: "field-timezone",
    keywords: ["المنطقة الزمنية", "توقيت", "timezone", "time zone"],
  },
  {
    id: "currency",
    labelKey: "workspace.b29b.currency.label",
    to: "settings/workspace",
    fieldId: "field-currency",
    keywords: ["عملة", "ريال", "دينار", "currency"],
  },
  {
    id: "hours",
    labelKey: "workspace.businessHours.title",
    to: "settings/workspace/hours",
    fieldId: "field-hours",
    keywords: ["دوام", "اوقات العمل", "ساعات العمل", "working hours", "opening hours"],
  },
  {
    id: "holidays",
    labelKey: "workspace.businessHours.holidays",
    to: "settings/workspace/hours",
    fieldId: "field-holidays",
    keywords: ["اجازة", "عطلة", "عيد", "holiday"],
  },
  {
    id: "notifications",
    labelKey: "notifications.prefs.title",
    to: "settings/notifications",
    fieldId: "field-notifications",
    keywords: ["اشعارات", "تنبيهات", "الجرس", "notifications", "alerts"],
  },
  {
    id: "quiet-hours",
    labelKey: "notifications.prefs.quietHours",
    to: "settings/notifications",
    fieldId: "field-notifications",
    keywords: ["هدوء", "لا تزعجني", "quiet hours"],
  },
];

export function matchSettingsFields(
  needle: string,
  label: (key: MessageKey) => string,
): readonly SettingsSearchEntry[] {
  const n = needle.trim().toLocaleLowerCase();
  if (!n) return [];
  return SETTINGS_SEARCH_INDEX.filter(
    (e) =>
      label(e.labelKey).toLocaleLowerCase().includes(n) ||
      e.keywords.some((k) => k.toLocaleLowerCase().includes(n)),
  );
}
